// Shared between the operator-monitoring API module and the feature views:
// the shape of a contract violation and the timeline key format.

export const TIMELINE_KEY = /^(message|event):[1-9]\d*$/

// Mirrors the backend error body `{ code, message }` that the shared axios
// interceptor hands to callers, so consumers read the status from `code` only.
export function contractError(code, message = 'Получен несовместимый ответ сервера') {
    const error = new Error(message)
    error.code = 503
    error.isContractError = true
    error.contractCode = code
    return error
}
